import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useMatch, useNavigate, useParams } from 'react-router-dom';

import { APP_URL_ACTIVITIES, APP_URL_ACTIVITY, APP_URL_CATALOG } from '../../../const';
import {
    addCategoryFilter,
    clearCategoriesError,
    clearFilters,
    fetchActivities,
    fetchAdvisors,
    fetchCategories,
    getCategoriesState
} from '../../../store/slices/catalogSlice';
import { setPageCssVariables } from '../../../utils/helper';
import Layout from '../Layout/Layout';
import CatalogFooter from './CatalogFooter';
import CatalogGrid from './CatalogGrid';
import CatalogSidebar from './CatalogSidebar';
import CatalogSubheader from './CatalogSubheader';
import styles from './styles.module.scss';

const getCategoriesFromParams = (params) => {
    const categoriesParams = params.category;

    if (!categoriesParams) {
        return [];
    }

    return categoriesParams.replace('category=', '').split(',');
};

const MarketPlace = () => {
    const dispatch = useDispatch();
    const { activeCategoriesFilters, categoriesList } = useSelector(getCategoriesState);
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const [parsedCategories, setParsedCategories] = useState(false);
    const isCatalog = useMatch(`${APP_URL_CATALOG}/*`);
    const isActivities = useMatch(`${APP_URL_ACTIVITIES}/*`);
    const isActivity = useMatch(`${APP_URL_ACTIVITY}/*`);

    const getParams = () => {
        if (isCatalog) {
            return {
                pathName: '/catalog',
                fetchFn: (params) => {
                    dispatch(fetchAdvisors({ page: 1, categories: params, reloading: true }));
                }
            };
        }
        if (isActivities || isActivity) {
            return {
                pathName: '/activities',
                fetchFn: (params) => {
                    dispatch(fetchActivities({ page: 1, categories: params, reloading: true }));
                }
            };
        }
        return null;
    };

    const pageParams = getParams();

    useEffect(() => {
        if (!categoriesList.length || !parsedCategories) {
            return;
        }

        const activeFiltersAlias = activeCategoriesFilters
            .map((category) => {
                const filter = categoriesList?.find((item) => item?.id === category);
                return filter?.alias;
            })
            .filter(Boolean);

        const newLocation = !activeFiltersAlias.length
            ? pageParams.pathName
            : `${pageParams.pathName}/category=${activeFiltersAlias.join(',')}`;

        if (newLocation === location.pathname) {
            return;
        }

        navigate(newLocation);
    }, [activeCategoriesFilters, categoriesList]);

    useEffect(() => {
        dispatch(fetchCategories());
    }, []);

    useEffect(() => {
        if (!categoriesList.length) {
            return;
        }

        const categoriesFromParams = getCategoriesFromParams(params);
        const activeFiltersAlias = categoriesFromParams
            .map((item) => {
                const filtered = categoriesList.find((category) => category.alias.toLowerCase() === item.toLowerCase());
                if (!filtered?.id) {
                    return '';
                }
                return filtered?.id;
            })
            .filter(Boolean);

        setParsedCategories(true);
        dispatch(addCategoryFilter({ filters: activeFiltersAlias, reset: true }));
    }, [categoriesList, dispatch, params.category]);

    useEffect(() => {
        return () => {
            dispatch(clearCategoriesError());
            dispatch(clearFilters());
        };
    }, [dispatch]);

    return (
        <div className={styles.catalog}>
            <CatalogSubheader pathName={pageParams.pathName} />
            <Layout innerContainerClassName={styles.container} isCatalogLayout={true} cssTypeVariable={'landing'}>
                <div className={styles.wrapper}>
                    <CatalogSidebar />
                    <CatalogGrid fetchFn={pageParams.fetchFn} isCatalog={isCatalog} isActivities={isActivities || isActivity} />
                </div>
            </Layout>
            <CatalogFooter />
        </div>
    );
};

export default MarketPlace;
